<template>
  <div id="offers-index" class="container offers-index">
    <div style="position: fixed; left: 15px; top: 70px; z-index: 10">
      <button class="btn btn-primary" v-b-toggle.search-and-filter>
        <b-icon icon="filter"></b-icon>
      </button>
    </div>
    <div class="text-center mt-5 mt-md-0">
      <strong class="h3">
        {{ translate('offers.title') }}
      </strong>
    </div>
    <hr class="custom-hr" />
    <div>
      <b-sidebar id="search-and-filter" title="Filter" shadow>
        <div class="px-3 py-2">
          <form method="POST" @submit.prevent="fetchOffers">
            <div class="form-group">
              <date-picker
                style="width: 100%"
                v-model="filter.start_date"
                placeholder="Start Date"
                input-class="form-control"
                valueType="format"
              ></date-picker>
            </div>
            <div class="form-group">
              <date-picker
                style="width: 100%"
                v-model="filter.end_date"
                placeholder="End Date"
                input-class="form-control"
                valueType="format"
              ></date-picker>
            </div>
            <div class="form-group">
              <label>Location</label>
              <multiselect
                v-model="selectedLocations"
                placeholder="Search regions or communities..."
                label="name"
                track-by="id"
                :options="initialLocations"
                :multiple="true"
                :taggable="false"
                :max-height="150"
                :limit="4"
                :showLabels="false"
                :loading="isLocationsLoading"
              ></multiselect>
            </div>
            <div class="form-group">
              <label>{{ translate('forms.specification') }}</label>
              <multiselect
                v-model="selectedSpecifications"
                :placeholder="translate('forms.search')"
                label="name"
                track-by="id"
                :options="initialSpecifications"
                :multiple="true"
                :taggable="false"
                :max-height="150"
                :limit="4"
                :showLabels="false"
                :loading="isSpecificationsLoading"
              ></multiselect>
            </div>
            <button class="btn btn-primary float-right" type="submit">
              {{ translate('buttons.get_result') }}
            </button>
          </form>
        </div>
      </b-sidebar>
    </div>

    <offers-grid :offers="offers" v-if="offers.length"></offers-grid>
    <ContentLoader v-if="!offers.length && !noData" />
    <div v-if="!offers.length && noData">
      <NoData
        :message="translate('fallback-messages.no_data_found')"
        class="text-center"
      />
    </div>
  </div>
</template>

<script>
import { getOffers } from '../api/services/offers'
import OffersGrid from '@/components/offers/OffersGrid'
import { formMultilSelectMixin } from '@/mixins/formMultilSelectMixin'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
  mixins: [formMultilSelectMixin],
  components: {
    OffersGrid,
    DatePicker
  },
  data() {
    return {
      offers: [],
      noData: false,
      filter: {
        page: 1,
        type: 2
      }
    }
  },
  mounted() {
    this.fetchOffers()
    this.getSpecificationsList()
    this.getLocations()
  },
  methods: {
    async fetchOffers() {
      try {
        this.isLoading = true
        this.noData = false
        this.offers = []

        let { data } = await getOffers(this.form, this.filter)
        this.offers = data
        if (!this.offers.length) {
          this.noData = true
        }
        this.isLoading = false
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-hr {
  border: none;
  height: 4px;
  background: #ff9a21;
  width: 200px;
  margin-bottom: 40px;
}
.offers-index {
  padding-bottom: 100px;
}
</style>